(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              // Initialize carousel after content is loaded
              this.initializeCarousel();
            }
            Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
    
    initializeCarousel() {
      const slider = this.querySelector('.nov-slider');
      if (slider && typeof $ !== 'undefined' && $.fn.slick) {
        const xs = parseInt(slider.dataset.xs) || 1;
        const sm = parseInt(slider.dataset.sm) || 2;
        const md = parseInt(slider.dataset.md) || 3;
        const lg = parseInt(slider.dataset.lg) || 4;
        const xl = parseInt(slider.dataset.xl) || 4;
        const xxl = parseInt(slider.dataset.xxl) || 4;
        const arrows = slider.dataset.arrows === 'true';
        const dots = slider.dataset.dots === 'true';
        const auto = slider.dataset.auto === 'true';
        const time = parseInt(slider.dataset.time) || 5;
        
        // Find the navigation buttons in the parent container
        const parentContainer = this.closest('[style*="position: relative"]');
        const prevButton = parentContainer ? parentContainer.querySelector('.nov-nav--prev') : null;
        const nextButton = parentContainer ? parentContainer.querySelector('.nov-nav--next') : null;
        
        $(slider).slick({
          slidesToShow: xl,
          slidesToScroll: 1, // Cambio a 1 para mejor control
          arrows: arrows,
          dots: dots,
          autoplay: auto,
          autoplaySpeed: time * 1000,
          swipe: true,
          swipeToSlide: true, // Permite deslizar libremente
          touchThreshold: 5, // Sensibilidad del touch
          touchMove: true,
          draggable: true,
          infinite: true, // Scroll infinito
          speed: 300, // Velocidad de transición más rápida
          cssEase: 'ease-in-out', // Transición suave
          useTransform: true, // Mejores animaciones
          prevArrow: arrows && prevButton ? prevButton : false,
          nextArrow: arrows && nextButton ? nextButton : false,
          responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: lg,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: lg,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: md,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: sm,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: xs,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
